<template>
    <div class="moble">
        <div class="fixed">
            <div class="box">
                <a :href="'tel:'+ config.footerTel">
                    <div class="img">
                        <span class="glyphicon glyphicon-earphone"></span>
                    </div>
                    <div class="txt">
                        拨打电话
                    </div>
                </a>
            </div>
            <div class="box">
                <a :href="'sms:'+ config.footerTel">
                    <div class="img">
                        <span class="glyphicon glyphicon-envelope"></span>
                    </div>
                    <div class="txt">
                        发送短信
                    </div>
                </a>
            </div>
            <div class="box" @click="code = !code">
                <div class="img">
                    <img src="/img/wechat.png" alt="">
                </div>
                <div class="txt">
                    添加微信
                </div>
            </div>
            <div class="box">
                <a href="https://map.baidu.com/poi/%E4%BB%80%E9%82%A1%E5%B8%82%E9%B9%8F%E6%88%90%E5%8C%96%E5%B7%A5%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/@11581529.493002774,3631753.004983395,17.85z?uid=250b25bff4daf02e750269a4&ugc_type=3&ugc_ver=1&device_ratio=2&compat=1&querytype=detailConInfo&da_src=shareurl">
                    <div class="img">
                        <span class="glyphicon glyphicon-map-marker"></span>
                    </div>
                    <div class="txt">
                        导航地址
                    </div>
                </a>
            </div>
        </div>
        <div class="code" v-show="code">
            <div>
                <div>
                    <div><img :src="config.qrcode" alt=""></div>
                    <div>微信扫描二维码可添加微信</div>
                </div>
                <div>
                    <span class="glyphicon glyphicon-remove" @click="code = !code"></span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            code:false,
            config
        }
    }
}
</script>
<style lang="less" scoped>
    .moble{
        display: none;
        .fixed{
            display: flex;
            position: fixed;
            left: 0;
            bottom: 0;
            height: 60px;
            width: 100vw;
            background-color: #337ab7;
            padding-top: 8px;
            z-index: 200;
            .box{
                flex: 1;
                text-align: center;
                color:#ffffff;
                line-height: 20px;
                img{
                    width: 28px;
                }
                span{
                    font-size: 20px;
                    margin-bottom: 8px;
                }
                a{
                    display: block;
                    color: #ffffff;
                    &:hover,&:visited,&:link{
                        color: #ffffff;
                        text-decoration: none;
                    }
                }
            }
        }
    }
    .code{
        z-index: 101;
        position: fixed;
        left: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0,0,0,0.8);
        display: -webkit-box;
        -webkit-box-pack: center;
        box-pack: center;
        -webkit-box-align: center;
        box-align: center;
        text-align: center;
        color: #ffffff;
        img{
            width: 40%;
            margin-bottom: 10px;
        }
        span{
            margin-top: 30vw;
        }
    }
    @media only screen and (max-width: 786px){
        .moble{
            display: block;
        }
    }
</style>